module.exports = __webpack_public_path__ + "static/media/krx-storyboard.e524b97c.jpg";